import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

// import { AuthService } from '../services/auth.service';
import { tap, finalize } from 'rxjs/operators';
import { EndpointsConstants } from 'app/shared/constants/endpoints.constants';
import { AuthService } from 'app/auth/services/auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    private injector: Injector,
    private authService: AuthService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let ok: string;
    const token = localStorage.getItem('token');

    let headers: HttpHeaders;
    if (
        req.url.includes(EndpointsConstants.task.uploadPlan) ||
        req.url.includes(EndpointsConstants.task.uploadLabel) ||
        req.url.includes(EndpointsConstants.task.import) ||
        req.url.includes(EndpointsConstants.taskIssues.uploadImage) ||
        req.url.includes(EndpointsConstants.assemblyOrder.uploadDetails)
      ) {
      headers = new HttpHeaders({
        'X-Api-Key': token ? token : ''
      });
    } else {
      headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Api-Key': token ? token : ''
      });
    }

    const clonedReq = req.clone({ headers: headers });
    return next.handle(clonedReq)
      .pipe(
        tap(
          event => { ok = event instanceof HttpResponse ? 'succeeded' : ''; },
          error => { ok = error; this.getError(error); }
          // Log when response observable either completes or errors
        ),
        finalize(() => {
          // this.loaderService.hide();
        })
      );
  }

  getError(error) {
    if (error.status === 401) {
      this.authService.logout();
    }
  }
}
